export enum AdditionalColourchipsLoadingState {
    Default = "default",
    Loading = "loading",
    Loaded = "loaded",
}
